<template>
  <!-- 最外层 -->
  <div
    class="list_one animationBox"
    @mouseenter="(e) => { this.module_isHover(e, true) }"
    @mouseleave="(e) => { this.module_isHover(e, false) }"
    :key="item.id"
    :style="{
      ...listOneStyle,
      ...box_shadow,
      borderRadius: pc_infor.borderRadius[pc_infor.borderRadius.radio_val].value + 'px',
      '--seBgColor':seBgColor,
      '--mbProNameFontSize':mbProNameFontSize
    }"
    data-comb-dom
  >
  <!-- 跳转视频详情 -->
    <router-link
      :to="'/video?'+ linkParam(item)"
      :target="fromTag === 'search' ? '_blank' : pc_infor.target"
      class="list_one_wrap font_hover_color border_hover_color"
      :class="(listArr.module_style == 3 || listArr.styleType === 'type1') && $store.state.app.view_pattern === 'pc' ? 'border_bottom_transition': ''"
      :style="{ ...$utils.getBackground(pc_infor.background)}"
    >
      <!-- 图片 -->
      <div
      v-if="listArr.module_style !== 3 || listArr.styleType === 'type1'"
        class="list_img_frame"
        :style="imgFrameStyle"
        ref="animationBox"
      >
        <div
        v-if="fromTag !=='search'"
          class="list_img animationImg"
          :style="{
            backgroundImage:item.img !== '' ?'url('+ item.img +')':'url('+ item.content +'?sec=1&w=300)',
            backgroundSize: pc_infor.backgroundSize.radio_val !== 'default' ? pc_infor.backgroundSize.custom.backgroundSize : ''
          }">
          <img
            :src="item.img !== '' ? item.img : '/static/image/noimage.jpg'" 
            :alt="item.name"
            :title="item.name" style="width: 100%; height: 100%; object-fit: cover;opacity: 0;">
          </div>
          <div
          v-else
            class="list_img animationImg"
            :style="{
              backgroundImage:item.img !== '' ?'url('+ item.img +')':'url('+ item.content +'?sec=1&w=300)',
              backgroundSize: pc_infor.backgroundType.radio_val !== 'default' ? pc_infor.backgroundType.custom.backgroundSize : ''
            }">
              <img
              :src="item.img !== '' ? item.img : '/static/image/noimage.jpg'" 
              :alt="item.name"
              :title="item.name" style="width: 100%; height: 100%; object-fit: cover;opacity: 0;">
            </div>
      </div>
      <div class="list_content_frame" :style="contentStyle">
        <div class="product_name_wrap">
          <span class="product_name" v-text="item.name" :style="pro_name_font"></span>
        </div>
        <div class="product_summary_wrap" v-if="$store.state.app.view_pattern === 'pc' && pc_infor.showSummary == 'true' ">
          <p class="product_summary" v-text="item.summary"  :style="pro_summary_font"></p>
        </div>
        <div class="product_prop_wrap" v-if="listArr.module_style !== 3 || fromTag === 'search'">
          <ul class="product_props">
            <li
              class="product_prop"
              v-for="(obj,i) in listArr.paraList"
              :key="i"
              v-if="(obj.show === true || obj.show === 'true' ) && item[obj.id] !== ''"
            >
              <template v-if="obj.id !== 'minimum'">
                <span class="prop_title" v-text="obj.title"></span>
                <span class="prop_value" v-text="item[obj.id]"></span>
              </template>
              <template v-if="obj.id === 'minimum' && item[obj.id] !== 0">
                <span class="prop_title" v-text="obj.title"></span>
                <span class="prop_value" v-text="item[obj.id]"></span>
              </template>
            </li>
          </ul>
        </div>
      </div>
    </router-link>
    <div class="tooptipPart module_edit_btn" v-if="isHover">
      <my_hover_btn :tips="$t('widgets_basic_video_display_components_one_img_2894')" btnIcon="el-icon-edit" @changeStyle="edit_pro"></my_hover_btn>
      <my_hover_btn v-if="!isSystem" :tips="$t('widgets_basic_video_display_components_one_img_2895')" btnIcon="el-icon-close" @changeStyle="del_pro(item)"></my_hover_btn>
    </div>
    <basic_addArticle
      :article-type="11"
      :edit-id="item.id"
      v-if="showAddArticle"
      @closed="closeAddArticle"
      @submit_sure="submitSure"
    ></basic_addArticle>
  </div>
</template>

<script>
import i18n from '../../../language/index'
import {getBoxShadowStyle} from '@/utils/utils'
import {font_set} from '@/base/background_set';

import {
  delPro
} from '@/api/app';
export default {
  name: "basic_product_display_one_img",
  data () {
    return {
      isHover: false,
      add_Product_isShow: false,
      isSystem: this.module.data.isSystem === 'true' ? true : false,
      showAddArticle:false
    };
  },
  props: {
    module: { //module数据
      type: Object,
      default: null
    },
    item: { // 当前循环的产品对象
      type: Object,
      default: null
    },
    hideBtn: { // 是否隐藏编辑和删除按钮
      type: Boolean,
      default: false
    },
    fromTag: { // 是否为全局搜索挂件
      type: String,
      default: ''
    }
  },
  watch: {
  },
  methods: {
    add_Product_close () {
      this.add_Product_isShow = false
    },
    submitSure () {
      this.$emit('getProduct')
      this.showAddArticle = false
    },
    edit_pro () { // 编辑产品
      this.showAddArticle = true
      this.$store.state.main_dialog.main_dialog_isShow = false
    },
    del_pro (item) { // 删除产品
      this.$confirm(i18n.t('widgets_basic_video_detail_components_one_img_2886'), '', {
        confirmButtonText: i18n.t('view_public_topbar_24'),
        cancelButtonText: i18n.t('view_public_topbar_11'),
        center: true,
        // customClass: 'del_dialog',
        appendToBody: true,
        closeOnClickModal: false,
        closeOnPressEscape: false
      }).then(() => {
        //this.deleteProduct(item.goods_id)
        this.$emit('delete_video', item.id)
      }).catch(() => {
      })
    },
    deleteProduct (id) {
      delPro({
        ids: id
      }).then(res => {
        if (res.code == 200) {
          this.$message.success(res.message)
          this.$emit('getProduct')
        } else {
          this.$message.error(res.message)
        }
      }).catch((res) => {
        this.$message.error(res.message)
      });
    },
    module_isHover (e, val) {
      if(this.$store.state.app.view_pattern === 'pc' && !this.hideBtn) {
        this.isHover = val;
        if (this.isHover) {
          this.templet.enter_animation(this.img_effects, e.target, this.$store.state.app.view_pattern)
        } else {
          this.templet.leave_animation(this.img_effects, e.target)
        }
      }
    },
    closeAddArticle () {
      this.showAddArticle = false
    },
  },
  computed: {
    listArr () {
      return this.module.data.listArr
    },
    pc_infor () {
      return this.module.data.pc_widgets_infor
    },
    widgets_infor () {
      return this.module.data[
        this.$store.state.app.view_pattern + "_widgets_infor"
      ];
    },
    contentStyle () {
      if(this.fromTag === 'search') {
        return false
      }
      let width = ''
      let pic_Width = parseFloat(this.pc_infor.pic_size[this.pc_infor.pic_size.radio_val].width.replace('%', ''))
      if(this.listArr.module_style === 2 && this.$store.state.app.view_pattern == 'pc') {
        pic_Width = 100 - pic_Width
        width = 'calc(' + pic_Width + '% - 20px)'
      }
      return {
        width: width
      }
    },
    listOneStyle () {
      let percent = 100
      if(this.fromTag === 'search') {
        if(this.$store.state.app.view_pattern == 'pc') {
          let marginLeft = this.pc_infor.margin[this.pc_infor.margin.radio_val].marginLeft
          let marginTop = this.pc_infor.margin[this.pc_infor.margin.radio_val].marginTop
          let col_num = 1
          if(this.listArr.module_style !== 'type1') {
            col_num = this.pc_infor.lineNumber[this.pc_infor.lineNumber.radio_val].value
          }
          let margin = marginTop / 2 + 'px ' + marginLeft / 2 + 'px '
          let width = 'calc(' + percent/col_num + '% - ' + marginLeft + 'px )'
          return {
            width: width,
            margin: margin
          }
        }
      } else {
        let col_num = 1
        if(this.listArr.module_style !== 2) {
          col_num = this.widgets_infor.col_num[this.widgets_infor.col_num.radio_val].value
        }
        let paddingLeft = this.pc_infor.padding[this.pc_infor.padding.radio_val].paddingLeft
        let paddingTop = this.pc_infor.padding[this.pc_infor.padding.radio_val].paddingTop
        let width = 'calc(' + percent/col_num + '% - ' + paddingLeft + 'px )'
        let padding = paddingTop / 2 + 'px ' + paddingLeft / 2 + 'px '
        if(this.$store.state.app.view_pattern == 'mb') {
          if(this.listArr.module_style === 0) {
            padding = '0 1.8% 20px 1.8%'
            width = (100 - 1.8*2*col_num)/col_num + '%'
            return {
              width: width,
              margin: padding
            }
          }
        } else {
          if(this.listArr.module_style !== 1) {
            return {
              width: width,
              margin: padding
            }
          } else{
            return {
              width: width,
              padding: padding
            }
          }
        }
      }
    },
    imgFrameStyle () {
      let paddingBottom = ''
      let width = ''
      if(this.fromTag === 'search') {
        if(this.listArr.styleType !== 'type1') {
          paddingBottom = this.pc_infor.height[this.pc_infor.height.radio_val].height
          return {
            paddingBottom: paddingBottom
          }
        }
      } else {
        if((this.listArr.module_style === 0 || this.listArr.module_style === 1)
        && this.pc_infor.img_size.radio_val === 'custom') {
          paddingBottom = this.pc_infor.img_size[this.pc_infor.img_size.radio_val].height
          return {
            paddingBottom: paddingBottom,
            width: width
          }
        } else if(this.listArr.module_style === 2 && this.pc_infor.pic_size.radio_val === 'custom') {
          if(this.$store.state.app.view_pattern == 'pc') {
            paddingBottom = this.pc_infor.pic_size[this.pc_infor.pic_size.radio_val].height
            width = this.pc_infor.pic_size[this.pc_infor.pic_size.radio_val].width
            return {
              paddingBottom: paddingBottom,
              width: width
            }
          }
        }
      }
    },
    img_effects () {
      return this.module.data.img_effects
    },
    is_road_type() {
      return this.$store.getters['app/is_road_type']
    },
    linkParam(){ // 外贸站的存在标签ID
      return item=>{
        let path = `id=${item.id}`
        return this.is_road_type? `${path}&tag_id=${item.tag_ids}`: path
      }
    },
    box_shadow() { // 阴影设置 只有PC端才能有阴影 其他的不存在
      return this.$store.state.app.view_pattern === 'pc' && this.fromTag !== 'search' ? (this.isHover ? getBoxShadowStyle(this.pc_infor.boxShadow, 'hover') : getBoxShadowStyle(this.pc_infor.boxShadow)) : {}
    },
    seBgColor() { // 悬浮背景色
      return this.fromTag !== 'search' ? this.pc_infor.background[this.pc_infor.background.radio_val].seColor: ''
    },
    pcInforFont() {
      return this.pc_infor.product_name_font[this.pc_infor.product_name_font.radio_val]
    },
    pro_name_font() {
      if(this.fromTag !== 'search'){
        let font =  font_set(this.pc_infor.product_name_font)
        font.textAlign = this.pc_infor.textAlign
        return font
      }else{
        return '';
      }
    },
    pro_summary_font() {
      if(this.fromTag !== 'search'){
        let font =  font_set(this.pc_infor.product_name_font)
        font.fontSize = (this.pcInforFont.fontSize - 4) + 'px'
        font.fontWeight = 'normal'
        font.textDecoration = 'normal'
        font.fontStyle = 'normal'
        font.opacity = 0.6
        font.textAlign= this.pc_infor.textAlign
        return font
      }else{
        return '';
      }
    },
    mbProNameFontSize() { // 手机端产品标题的字号
      return this.fromTag !== 'search' ? (Number(this.pcInforFont.fontSize)-2) + 'px' : '16px'
    }
  },
  components: {},
  created () { },
  mounted () {
    this.templet.initImageAnimation(this.img_effects, this.img_effects, this.$refs.animationBox, this.$store.state.app.view_pattern)
  }
};
</script>

<style scoped lang="scss">
.list_one {
  position: relative;
  box-sizing: border-box;
  min-height: 30px;
  min-width: 30px;
  height: 100%;
  width: calc(25% - 20px);
  transition: all 0.5s ease-out;
  display: inline-block;
  text-align: center;
  box-sizing: border-box;
  margin: 10px;
  background-color: #fff;
  vertical-align: top;
  // overflow: hidden;
  .tooptipPart {
    right: 0;
    bottom: 0;
    top: auto;
    display: block;
    z-index: 999;
  }
  .list_one_wrap {
    position: relative;
    z-index: 1;
    padding: 5%;
    display: block;
    height: 100%;
    overflow: hidden;
    color: #333;
    .list_img_frame {
      position: relative;
      padding-bottom: 100%;
      overflow: hidden;
      .list_img {
        position: absolute;
        width: 100%;
        height: 100%;
        cursor: pointer;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        // transition: all 0.36s ease;
      }
    }
    .list_content_frame {
      box-sizing: border-box;
      overflow: hidden;
      .product_name_wrap {
        color: inherit;
        line-height: 24px;
        white-space: normal;
        margin-bottom: 5px;
        margin-top: 15px;
        .product_name {
          color: inherit;
          font-size: 16px;
          vertical-align: middle;
          word-break: normal;
          white-space: normal;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          max-height: 48px;
          text-align: left;
          padding-right: 3px;
        }
      }
      .product_prop_wrap {
        .product_props {
          padding: 0;
          margin: 0;
          list-style-type: none;
        }
        .product_prop {
          word-break: keep-all;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          .prop_title:after {
            content: "：";
          }
          span {
            color: #666;
            font-size: 14px;
          }
        }
      }
      .product_summary{
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        // max-height: 42px;
        text-align: left;
      }
    }
  }
  .border_bottom_transition {
    position: relative;
    transition: 0.5s;
    border-color: transparent;
  }
  .border_bottom_transition::before {
    transform-origin: 0 100%;
    border-bottom: 3px;
    border-bottom-style: solid;
    border-color: inherit;
  }
  .border_bottom_transition::after,
  .border_bottom_transition::before {
    width: 100%;
    height: 100%;
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    box-sizing: border-box;
    transition: -webkit-transform 0.36s ease;
    transition: transform 0.36s ease;
    transition: transform 0.36s ease, -webkit-transform 0.36s ease,
      -moz-transform 0.36s ease, -o-transform 0.36s ease;
  }
}
.list_one {
  .list_one_wrap {
    &.font_hover_color:hover {
      color: var(--theme_color);
    }
    &:hover{
      background-color:var(--seBgColor) !important;
      .list_content_frame{
        .product_name_wrap{
          .product_name{
             color: var(--theme_color) !important;
          }
        }
      }
    }
  }
  .border_hover_color:hover {
    border-color: var(--theme_color);
  }
}
  .pc_pattern {
    .basic_product_display_index {
      .product_list_1 {
        .list_one {
          &:hover .list_one_wrap{
            box-shadow: rgba(0, 0, 0, 0.1) 0 0 15px;
          }
        }
      }
    }
    .product_list_0,.product_list_2,.product_list_3 {
      .list_one {
        &:hover {
          box-shadow: rgba(0, 0, 0, 0.1) 0 0 15px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/widgets/basic_video_display/components/one_img.vue